import { padding, PaddingProps } from '@lib/style/mixins/padding';
import DialogTitle, { DialogTitleProps } from '@material-ui/core/DialogTitle';
import * as React from 'react';
import styled from 'styled-components';

type Props = Partial<DialogTitleProps & PaddingProps>;

export const DialogHeader = styled(({ ...rest }: Props) => <DialogTitle {...rest} />)
    .attrs<Props>(({ disableTypography }) => ({
        disableTypography: disableTypography ?? true,
    }))
    .withConfig<Props>({
        shouldForwardProp: (prop: any) => !['p', 'padding'].includes(prop),
    })<Props>`
    && {
        width: 100%;
        ${padding('16px 20px')};
    }
`;
